<template>
	<div class="modal-card">
		<div class="modal-card-head">
			<h2 class="modal-card-title">{{ questionnaire.Entity }} {{ questionnaire.Period }}</h2>
		</div>
		<div class="modal-card-body">
			<div class="columns is-multiline">
				<div class="column is-6">
					<b-field label="Variable A">
						<b-input v-model="enforceability.A" type="number" step=".5" min="0" max="5"></b-input>
					</b-field>
					<b-field label="Variable B">
						<b-input v-model="enforceability.B" type="number" step=".5" min="0" max="5"></b-input>
					</b-field>
				</div>
				<div class="column is-6">
					<b-field label="Variable C">
						<b-input v-model="enforceability.C" type="number" step=".5" min="0" max="5"></b-input>
					</b-field>
					<b-field label="Variable D">
						<b-input v-model="enforceability.D" type="number" step=".5" min="0" max="5"></b-input>
					</b-field>
				</div>

				<div class="column is-12">
					<b-field label="Explanatory Comments">
						<editor apiKey="0qgi7f55b2ue7vvn7vvi7w9zim05110j4aznns846hbq588x" v-model="enforceability.ExplanatoryComments" :init="{
							menubar: false,
							plugins: ['autoresize', 'wordcount'],
							toolbar:
								'formatselect | bold italic underline | \
            bullist numlist outdent indent | removeformat | spellchecker',
							browser_spellcheck: true
						}"></editor>
					</b-field>
					<b-field label="Practical actions to improve score">
						<editor apiKey="0qgi7f55b2ue7vvn7vvi7w9zim05110j4aznns846hbq588x" v-model="enforceability.ImprovingScore" :init="{
							menubar: false,
							plugins: ['autoresize', 'wordcount'],
							toolbar:
								'formatselect | bold italic underline | \
            bullist numlist outdent indent | removeformat | spellchecker',
							browser_spellcheck: true
						}"></editor>
					</b-field>
					<b-field label="Acknowledgements">
						<editor apiKey="0qgi7f55b2ue7vvn7vvi7w9zim05110j4aznns846hbq588x" v-model="enforceability.Acknowledgements" :init="{
							menubar: false,
							plugins: ['autoresize', 'wordcount'],
							toolbar:
								'formatselect | bold italic underline | \
            bullist numlist outdent indent | removeformat | spellchecker',
							browser_spellcheck: true
						}"></editor>
					</b-field>
				</div>
				<b-upload accept=".pdf,.doc,.docx," v-model="File">
					<a class="button is-primary" icon="fad fa-upload">Upload Annotations</a>
					<span style="margin-left: 7px; margin-top: 5px" class="has-text-weight-bold" v-if="File">
						{{ File.name }}
					</span>
				</b-upload>

			</div>
		</div>
		<div class="modal-card-foot">
			<div>
				<p>Final Score: {{ Score }}</p>
				<p>Category: {{ Category }}</p>
			</div>
			<div>
				<b-button @click="close()">Cancel</b-button>
				<b-button @click="save()" class="is-primary">Save</b-button>
			</div>
		</div>
	</div>
</template>
<script>
	import Editor from "@tinymce/tinymce-vue";
	export default {
		components: {
			editor: Editor
		},
		data() {
			return {
				enforceability: {},
				ranges: undefined,
				File: ""
			};
		},
		props: {
			questionnaire: Object,
			model: Object
		},
		computed: {
			Category() {
				var score = this.Score;
				if (score >= 87 && score <= 100) {
					return "Very High";
				} else if (score >= 75 && score < 87) {
					return "High";
				} else if (score >= 50 && score < 75) {
					return "Medium";
				} else if (score >= 0 && score < 50) {
					return "Low";
				} else {
					return "Not Defined";
				}
			},
			Score() {
				return this.$score_enforceability(
					this.enforceability.A,
					this.enforceability.B,
					this.enforceability.C,
					this.enforceability.D,
				);
			},
			Operation() {
				if (this.model.Id) return "Edit";
				else return "Add";
			}
		},
		methods: {
			close(prop) {
				this.$emit("close", prop);
			},
			async save() {
				this.enforceability.Score = this.Score;
				this.enforceability.Category = this.Category;
				await this.$http
					.post("api/questionnaire/enforceability/save", this.enforceability)
					.then(async (resp) => {
						if (this.File) {
							await this.uploadDocument();
						}
						this.close();
						this.$buefy.toast.open({ message: "Questionnaire Saved!", type: "is-success" });
					})
					.catch((err) => {
						console.error(err);
						this.$buefy.toast.open({
							duration: 5000,
							type: "is-danger",
							message: "Failed to save the questionnaire. An error occurred."
						});
					});
			},
			async uploadDocument() {
				var formData = new FormData();
				formData.append("file", this.File);
				await this.$http
					.post("api/document?type=2", formData, { headers: { "Content-Type": "multipart/form-data" } })
					.then(async (resp) => {
						if (resp.data == "Document was not uploaded properly") {
							this.$buefy.notification.open({
								duration: 4000,
								message: "An error occurred. Please try again later.",
								type: "is-danger"
							});
						} else {
							const qs = "?type=2";
							await this.$http
								.post("api/document/annotation" + qs, {
									QuestionnaireId: this.questionnaire.Id,
									GroupId: this.enforceability.GroupId,
									PeriodId: this.enforceability.PeriodId,
									S3Name: resp.data
								})
								.then(async (resp) => {
									if (resp.data) {
										this.$buefy.notification.open({
											duration: 4000,
											message: "Document uploaded successfully",
											type: "is-success"
										});
									}
								})
								.catch((err) => {
									console.error(err);
								});
						}
					})
					.catch((err) => {
						console.error(err);
					});
			}
		},
		created() {
			this.enforceability = this.model;
		}
	};
</script>
